<template>
  <a-modal
    centered
    title="修改信息"
    v-model="visible"
    @cancel="visible = false"
    @ok="onSubmit"
    :maskClosable="false"
    :confirmLoading="loading"
    width="800px"
  >
    <div>
      <data-form
        ref="orderForm"
        labelSize="small"
        :content="orderFormContent"
        :fixedLabelWidth="true"
        :labelCol="5"
        :wrapperCol="19"
        :colnum="3"
        :showButton="false"
      >
      </data-form>
    </div>
  </a-modal>
</template>
<script>
import { DataForm } from "@/components/dataForm";
export default {
  components: {
    DataForm
  },
  data() {
    return {
      visible: false,
      orderInfo: {},
      loading: false,
      orderFormContent: [
        {
          label: "就餐人数",
          name: "PersonCount",
          type: "number",
          option: {
            initialValue: 1
          }
          // min: 1
        },
        {
          label: "客源",
          name: "GuestSourceId",
          type: "select",
          api: "Common_GetSelect",
          param: { Types: "ResGuestSource" },
          dataField: "Data.ResGuestSource"
        },
        {
          label: "客户",
          name: "CustomerId",
          type: "select",
          api: "Common_GetSelect", //请求接口api
          param: { Types: "customer" }, //请求参数
          dataField: "Data.customer", //请求可选项返回的数据字段
          props: {
            showSearch: true,
            optionFilterProp: "children"
          }
        },
        {
          name: "SalesmanName",
          type: "hidden"
        },
        {
          label: "业务员",
          name: "SalesmanId",
          type: "select",
          api: "Common_GetSelect", //请求接口api
          param: { Types: "Salesman" }, //请求参数
          dataField: "Data.Salesman", //请求可选项返回的数据字段
          onChange: this.onSalesmanChange
        },
        {
          label: "联系人",
          name: "Contact"
        },

        {
          label: "电话",
          placeholder: "请输入电话",
          // slot: "phone",
          name: "Phone",
          option: {
            rules: [
              {
                validator: (rule, value, callback) => {
                  const val = value && value.trim();
                  if (val && !/^1[3456789]\d{9}$/.test(val)) {
                    callback(new Error("电话号码格式错误!"));
                  } else {
                    callback();
                  }
                }
              }
            ]
          }
        },
        {
          label: "备注",
          name: "OrderRemark",
          type: "textarea",
          colnum: 3
        }
      ]
    };
  },
  created() {},
  methods: {
    show(orderInfo) {
      this.visible = true;
      this.orderInfo = orderInfo;
      this.$nextTick(() => {
        this.$refs.orderForm.setData(orderInfo);
      });
    },
    onSalesmanChange(val, row) {
      const name = val ? row.Text : "";
      this.$refs.orderForm.setData({
        SalesmanName: name
      });
    },
    onCancel() {
      this.visible = false;
    },
    onSubmit() {
      this.$refs.orderForm.getData(true).then(values => {
        this.loading = true;
        this.$post("EditRestaurantOrderBaseInfo", {
          Id: this.orderInfo.Id,
          ...values
        })
          .then(() => {
            this.$emit("submit");
            this.visible = false;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
